import * as $ from "jquery"
import { IMtCaptcha } from "mt-captcha/IMtCaptcha";
import { Resources } from "../../../../Common/Web.UI/CommonContent/scripts/app/global/resources";
import { AjaxServiceResponse } from "../../../../Common/Web.UI/CommonContent/scripts/app/global/service-response";
import { App } from "../../../../Common/Web.UI/CommonContent/scripts/app/_app";

declare const mtcaptcha: IMtCaptcha;

export class ContactEvidence {

    static init(): void {
        if (document.getElementById("contact-form") != null) {
            const $contactForm = $("#contact-form");
            $contactForm.validate({
                submitHandler: function (form: HTMLFormElement) {
                    App.Common.Functions.buttonLoader("submitContactForm", true);


                    document.getElementById("error-container").innerHTML = "";

                    $.ajax({
                        url: form.getAttribute("action"),
                        type: "POST",
                        data: {
                            __RequestVerificationToken: $("input[name=\"__RequestVerificationToken\"]", form).val(),
                            "name": $("#name").val() || "",
                            "email": $("#email").val() || "",
                            "licenseplate": $("#licenseplate").val() || "",
                            "telephone": $("#telephone").val() || "",
                            "subject": $("#subject").val() || "",
                            "message": $("#message").val() || "",
                            "CaptchaToken": $("#contact-form").find(".mtcaptcha-verifiedtoken").first().val()
                        },
                        success: function (response: AjaxServiceResponse) {
                            if (response.Status === App.Common.Constants.Api.ResponseMessage.Success) {
                                $("#contact-main-form").hide();
                                $("#faqPageLink").hide();
                                $("#startPageLink").show();

                                $("#infobox").html($("#hide-on-scroll").data("sent"));

                                $contactForm.trigger("reset");
                                $("#faqCategory").val("0");
                                document.getElementById("error-container").innerHTML = App.Common.Functions.Alerts.getSuccessHtml(response.Message);
                                $contactForm.find("input[type=text], input[type=email], textarea").val("");
                                $(".sent").each(function () {
                                    $(this).html($(this).data("sent"));
                                });
                            } else {
                                document.getElementById("error-container").innerHTML = App.Common.Functions.Alerts.getDangerHtml(response.Message);
                                $(window).scrollTop(0);
                            }
                            const mtCaptcha = document.getElementsByClassName("mtcaptcha");
                            for (let i = 0; i < mtCaptcha.length; i++) {
                                mtcaptcha.resetUI(mtCaptcha[i].id);
                            }
                        },
                        error: function (jqXHR: JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus, errorThrown: string) {
                            App.Common.Logging.logConsole("error", jqXHR, textStatus, errorThrown);
                            document.getElementById("error-messages").innerHTML = App.Common.Functions.Alerts.getDangerHtml(Resources.ErrorMessages.serverError);
                            $(window).scrollTop(0);
                        },
                        complete: () => {
                            App.Common.Functions.buttonLoader("submitContactForm", false);
                        }
                    });
                    return false;
                },
                rules: {
                    Email: {
                        required: true,
                        emailRegex: true
                    },
                    Telephone: {
                        telRegex: true
                    },
                    Licenseplate: {
                        hasUnicodeNumberSpaceMinus: true
                    },
                    Message: {
                        required: true,
                        maxlength: 2000
                    },
                    "mtcaptcha-verifiedtoken": {
                        required: {
                            depends: function () {
                                return $("#contact-form").find(".mtcaptcha-verifiedtoken").length > 0;
                            }
                        }
                    }
                },
                messages: {
                    Name: {
                        required: Resources.ErrorMessages.fieldRequiredError
                    },
                    Email: {
                        required: Resources.ErrorMessages.emailRequiredError,
                        email: Resources.ErrorMessages.emailNotValid
                    },
                    Telephone: {
                        telRegex: Resources.ErrorMessages.errorTelRegex
                    },
                    Licenseplate: {
                        hasUnicodeNumberSpaceMinus: Resources.ErrorMessages.errorHasUnicodeNumberSpaceMinus
                    },
                    Message: {
                        required: Resources.ErrorMessages.fieldRequiredError,
                        maxlength: Resources.ErrorMessages.errorMaxLength
                    },
                    "mtcaptcha-verifiedtoken": {
                        required: Resources.ErrorMessages.captchaRequiredError
                    }
                }
            });

        }
    }
}